import React, {useState, useContext, useRef} from "react";
import {useForm} from "react-hook-form";
import {useHistory, useParams} from "react-router-dom";

import GenericTemplate from "../../templates/GenericTemplate";
import {RoleSetGroup} from "./RoleEdit";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../atom/Apollo_Context";
import {apollo_user_path,
  apollo_accountgroups_path,
  users_path,
  apollo_user_role_path,
  signin_path,
  signout_api
} from "../../atom/Apollo_links";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {EditUsers, AccountGroups, UserRolesRequest, UpdateUserRoles} from "./UserModel";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloUserProfileAuth, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import axios from "axios";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
// メッセージ定義
import {
  GetMessage,
  UI_USER_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpiredSpecify} from "../../atom/Apollo_Expired";

import moment from "moment";

const initRoles: UserRolesRequest = {
  role:[],
}

const initUpdateUserRoles: UpdateUserRoles = {
  familyName: "",
  firstName: "",
  mailaddress: "",
  organization: "",
  systemAdminFlg: 0,
  deleteUserRoles: initRoles,
  createUserRoles: initRoles,
};

type UserRequest = EditUsers & {
  isRoleChange: boolean,
}

const UserEdit: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  type FormData = {
    mailAddress: string,
    familyName: string,
    firstName: string,
    orzanization: string,
  };

  const formHooks = useForm<FormData>();
  const {register, handleSubmit, errors, formState} = formHooks;

  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = useContext(ApolloMessage);

  const [roleIndexes, setRoleIndexes] = useState([1]);
  const [user, setUser] = useState<UpdateUserRoles>(initUpdateUserRoles);
  const [accountGroups, setAccountGroups] = useState<AccountGroups[]>([]);
  const [accountGroupsSelect, setAccountGroupsSelect] = useState<AccountGroups[]>([]);
  const [systemAdmin, setSystemAdmin] = useState(0);
  const [checkSysAd, setCheckSysAd] = useState(false);

  const processing = useRef(false);
  // ロール情報
  const updateRoleIdlist = React.useRef<any>([]);
  const [returnPage, setReturnPage] = useState(false);
    
  // 操作前データ
  const beforeData = React.useRef<any>(useParams<{userid: string}>());
  const beforeData2 = React.useRef<any>([]);
  const requestData = React.useRef<any>(null);
  const requestData2 = React.useRef<any>(null);
  const resultData = React.useRef<any>(null);
  const resultData2 = React.useRef<any>([]);
  const resultApi = React.useRef(-1);
  const logTime = React.useRef("");
  // ロール変更有無
  const isRoleChange = React.useRef<boolean>(false);

  let accountGroups1: Array<AccountGroups> = [];
  let accountGroupsSelect1: Array<AccountGroups> = [];

  // 0: 新規, アカウントグループID: 編集
  const {userid} = useParams<{userid: string}>();

  // ロール追加ハンドラ
  const addRoles = () => {
    // @ts-ignore
    setRoleIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
    // 選択中のアカウントグループを除外する
    updateAccountGroups();
  };

  // ロール削除ハンドラ
  const removeRoles = (index: any) => () => {
    setRoleIndexes(current => [...current.filter(i => i !== index)]);
    // 選択中のアカウントグループを追加する
    updateAccountGroups();
  };

  // 登録・更新ハンドラ
  const onSubmit = handleSubmit(async (data: any) => {
    if (formState.isSubmitting) return;
    if (processing.current) return;

    let existsSelect = false;
    let isError = false;

    let updateRoleIds = document.querySelectorAll('[id^=role_id]');
    updateRoleIdlist.current = updateRoleIds;

    if (userid === "0") {
      if ((typeof data.role_id !== 'undefined' && data.role_id.length === 1 && typeof data.role_id[0] !== 'undefined') ||
        (typeof data.role_id !== 'undefined' && data.role_id.length === 2 && typeof data.role_id[1] !== 'undefined')) {
        existsSelect = true;
      }

      updateRoleIds.forEach(function (updateRoleId: any) {
        if (updateRoleId?.className === "") {
          isError = true;
        }
      })

      if (!isError && !existsSelect && typeof data.role_id === 'undefined') {
        isError = true;
      }

      if (!isError && !existsSelect && typeof data.role_id[1] === 'undefined') {
        isError = true;
      }
    } else {
      if (updateRoleIds.length === 0) {
        isError = true;
      }

      if (!isError) {
        updateRoleIds.forEach(function (updateRoleId: any) {
          if (updateRoleId?.className === "") {
            isError = true;
          }
        })
      }
    }

    if (isError) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_USER_EDIT,"V","0"),
        }
      });
      return;
    }

    let accountGrouops = document.querySelectorAll('[id^=role_accountgroup]');

    let count1 = 0;
    let isDupulication = false;

    accountGrouops.forEach(function (ag1: any) {
      accountGrouops.forEach(function (ag2: any) {
        if (ag1?.className === ag2?.className) {
          count1++;
        }
      })

      if (count1 > 1) {
        isDupulication = true;
      }
      count1 = 0;
    })

    if (isDupulication) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_USER_EDIT,"V","1"),
        }
      });
      return;
    }

    // ロールとユーザー紐付け
    var createRoles:string[] = [];

    if (userid === "0") {
      processing.current = true;

      //@ts-ignore
      updateRoleIdlist.current.forEach(function (updateRoleId: any) {
        createRoles.push(updateRoleId?.className);
      });
      var userRolesRequest:UserRolesRequest = {role:createRoles};

      var userRequest: UpdateUserRoles = {
        familyName: data.familyName,
        firstName: data.firstName,
        mailaddress: userid === "0" ? data.mailAddress : user.mailaddress,
        organization: data.orzanization,
        systemAdminFlg: systemAdmin,
        deleteUserRoles: initRoles,
        createUserRoles: userRolesRequest,
      };

      // 操作ログ用にリクエストデータ保存
      requestData.current = userRequest;
      // 操作後データ保存
      requestData2.current = data;
      // 操作日時をセット
      logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
      // 操作ログ出力(更新)
      resultApi.current = 0;
      writeLog();

      // ユーザー作成
      let url = `${apollo_user_role_path}`;
      await ApolloAxios.post(url,userRequest).then((response) => {

        var paramUserId = response.data.result.id;

        // 操作ログ(成功)
        resultApi.current = 1;
        resultData.current = paramUserId;
        // 操作ログ(ロール追加)
        resultData2.current = resultData2.current.push(userRolesRequest.role.join());
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_USER_EDIT,"I","0"),
          }
        });
        // ユーザ一覧に新規追加ユーザーを反映させる用
        history.goBack();

      }).catch((err) => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        let errorMessage = err?.response?.data?.message || err?.errmsg || "server error";

        if (errorMessage.indexOf("overlapping mailaddress") !== -1) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_USER_EDIT,"V","2"),
            }
          });
          return;
        }

        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpiredSpecify(err, GetMessage("0",UI_USER_EDIT,"E","0"), data, setmsg, history, users_path)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
        // エラー時に一覧に戻さない
        // history.goBack();
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        processing.current = false;
      })
    } else {
      // 更新
      isRoleChange.current = false; 
      if (checkSysAd) {
        isRoleChange.current = true;
      }

      // ロール変更前
      roleIds.sort(
        function(a,b){
          return (a < b ? 1 : -1);
        }
      );
      let beforeRoles = roleIds.join('，');

      // ロール変更後
      let arrAfter1: number[] = [];

      updateRoleIds.forEach(function (updateRoleId: any) {
        arrAfter1.push(Number(updateRoleId?.className))
      });

      arrAfter1.sort(
        function(a,b){
          return (a < b ? 1 : -1);
        }
      );
      let afterRoles = arrAfter1.join('，');

      var userRolesUpdateRequest:UserRolesRequest = {role:createRoles};

      var userRequest: UpdateUserRoles = {
        familyName: data.familyName,
        firstName: data.firstName,
        mailaddress: userid === "0" ? data.mailAddress : user.mailaddress,
        organization: data.orzanization,
        systemAdminFlg: systemAdmin,
        deleteUserRoles: userRolesUpdateRequest,
        createUserRoles: userRolesUpdateRequest,
      };

      // 操作前データ保存
      beforeData2.current = beforeRoles;
      // 操作後データ保存
      requestData2.current = afterRoles;
      // 操作ログ用にリクエストデータ保存
      requestData.current = userRequest;
      // 操作日時をセット
      logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
      // 操作ログ出力(更新)
      resultApi.current = 0;
      writeLog();

      if (beforeRoles !== afterRoles) {
        isRoleChange.current = true;
        // 削除ロール
        var deleteRoles:string[] = [];
        roleIds.forEach(function (roleId: any) {
          if (!arrAfter1.includes(roleId)) {
            // 削除ロールIDを追加
            deleteRoles.push(roleId + "");
          }
        });
        var deleteRolesRequest:UserRolesRequest = {role:deleteRoles};
        userRequest.deleteUserRoles = deleteRolesRequest;

        // 追加ロール
        var createRoles:string[] = [];
        arrAfter1.forEach(function (roleId: any) {
          if (!roleIds.includes(roleId)) {
            // 削除ロールにない場合、ロールを追加する
            createRoles.push(roleId + "");
          }
        });
        var createRoleRequest:UserRolesRequest = {role:createRoles};
        userRequest.createUserRoles = createRoleRequest;

      }

      if (isRoleChange.current && userRequest.mailaddress === state.userprofile.mailAddress) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "info",
            message: GetMessage("0",UI_USER_EDIT,"V","3"),
          }
        });
      }

      processing.current = true;

      // ユーザー更新
      let url = `${apollo_user_role_path}/${userid}`;
      ApolloAxios.put(url, userRequest).then((response) => {
        // 操作ログ(成功)
        resultApi.current = 1;
        // 成功メッセージ表示
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: GetMessage("0",UI_USER_EDIT,"I","1"),
          }
        });
        // 呼び出し元画面に戻る
        setReturnPage(!returnPage);
      }).catch((err) => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        let errorMessage = err?.response?.data?.message || err?.errmsg || "server error";

        if (errorMessage.indexOf("overlapping mailaddress") !== -1) {
          // メールアドレス重複エラーメッセージ表示
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_USER_EDIT,"V","4"),
            }
          });
          return;
        }

        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpiredSpecify(err, GetMessage("0",UI_USER_EDIT,"E","1"), data, setmsg, history, users_path)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }

        // エラー時に一覧に戻さない
        // history.goBack();
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        processing.current = false;
      });
    }
  });
  
  // 呼び出し元画面に戻る
  React.useEffect(() => {
    if (!returnPage) return;
    // 自身のユーザー情報を変更した場合、再ログイン
    if (isRoleChange.current && requestData.current.mailaddress === state.userprofile.mailAddress) {
      const urlstring = process.env.REACT_APP_API_ENDPOINT + signout_api;

      var senddata = {
        accountGroupId: state.current.accountGroupId,
        accountId: state.current.accountId,
        trackerId: state.current.trackerId,
        campaignId: state.current.campaignId,
      }

      processing.current = true;
      axios.post(urlstring, senddata, {
        xsrfHeaderName: 'X-CSRF-Token',
        withCredentials: false,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      })
        .then(function (response) {
          history.push(signin_path);
        })
        .catch(function (error) {
          history.push(signin_path);
        }).finally(() => {
          processing.current = false;
        });
      dispatch({
        type: "clearAccount",
        payload: {
          ...state,
        }
      })

      localStorage.clear();
      history.push(signin_path);
    } else {
      // 呼び出し元画面に戻る
      history.goBack();
    }
  }, [returnPage])
  
  // 初期処理
  let num1: number[] = [];
  const [roleIds, setRoleIds] = useState(num1);
  const [accountGroupRead, setAccountGroupRead] = useState(false);
  let roleId1: Array<number> = [];

  React.useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })

    // ユーザー情報取得URL
    var url = `${apollo_user_path}${state.userprofile.userId}`;

    // システム管理者の場合
    if (state.userprofile.systemAdmin === 1) {
      var url = `${apollo_accountgroups_path}`;

      ApolloAxios.get(url).then((response) => {
        response.data.result.forEach(function (r1: any) {
          let ag1: AccountGroups = {
            value: r1.accountgroupId,
            label: r1.accountgroupName,
          }
          accountGroups1.push(ag1);
        })
        setAccountGroupRead(!accountGroupRead);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      }).catch((err) => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpiredSpecify(err, GetMessage("0",UI_USER_EDIT,"E","4"), data, setmsg, history, users_path)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      })
    } else {
      setAccountGroupRead(!accountGroupRead);
    }
  }, [])

  React.useEffect(() => {
    if (!accountGroupRead) return;
    if (userid !== "0") {
      // ユーザー取得
      var urlUser = `${apollo_user_path}${userid}`;

      ApolloAxios.get(urlUser).then((response2) => {
        // 編集ユーザーの権限(チェックボックス用)
        if (response2.data.result.systemAdminFlg !== "0") {
          setSystemAdmin(parseInt(response2.data.result.systemAdminFlg));
        }

        setUser(response2.data.result);
        // 操作前データ保存
        beforeData.current = JSON.parse(JSON.stringify(response2.data.result));

        if (state.userprofile.systemAdmin === 1) {
          for (var i = 0; i < response2.data.result.userRoleInfo.length; i++) {
            roleId1.push(response2.data.result.userRoleInfo[i].roleId)
            setRoleIds(roleId1);
            setRoleIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
            // 選択しているアカウントグループ名を追加
            accountGroupsSelect1.push({
              value: "",
              label: response2.data.result.userRoleInfo[i].accountGroupName,
            })
          }
          state.apolloList.forEach(function (list1: any) {
            let ag1: AccountGroups = {
              value: list1.accountGroup.id,
              label: list1.accountGroup.name,
            }
            accountGroups1.push(ag1);
            // 選択しているアカウントグループIDをセット
            accountGroupsSelect1.map((sel) => {
              if (sel.label === list1.accountGroup.name) {
                sel.value = list1.accountGroup.id;
              }
            });
          });
        } else {
          let result1: any = response2.data.result;

          state.apolloList.forEach(function (list1: any) {
            if (list1.accountGroup.roleAuthorization < 20) {
              return
            }

            for (var i = 0; i < result1.userRoleInfo.length; i++) {
              if (result1.userRoleInfo[i].accountGroupName === list1.accountGroup.name) {
                roleId1.push(result1.userRoleInfo[i].roleId)
                setRoleIds(roleId1);
                setRoleIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
                // 選択しているアカウントグループ名を追加
                accountGroupsSelect1.push({
                  value: "",
                  label: response2.data.result.userRoleInfo[i].accountGroupName,
                })
              }
            }

            let ag1: AccountGroups = {
              value: list1.accountGroup.id,
              label: list1.accountGroup.name,
            }
            accountGroups1.push(ag1);
            // 選択しているアカウントグループIDをセット
            accountGroupsSelect1.map((sel) => {
              if (sel.label === list1.accountGroup.name) {
                sel.value = list1.accountGroup.id;
              }
            });
          })
        }

        setAccountGroups(accountGroups1);
        setRoleIndexes(current => [...current.filter(i => i !== 1)]);
        let accountGroupsWork:AccountGroups[] = [];
        accountGroups1.forEach(function (ag1: AccountGroups) {
          let flag = false;
          accountGroupsSelect1.forEach(function (ag2: AccountGroups) {
            // アカウントグループオプションのアカウントグループID(数値)と選択中のアカウントグループID(文字)を比較
            if (ag1.label === ag2.label) {
              flag = true;
            }
          })
          if (!flag) {
            // 未選択のアカウントグループを追加する
            accountGroupsWork.push(ag1);
          }
        })
        setAccountGroupsSelect(accountGroupsWork);

      }).catch((err) => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpiredSpecify(err, GetMessage("0",UI_USER_EDIT,"E","5"), data, setmsg, history, users_path)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      });
    } else {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      if (state.userprofile.systemAdmin !== 1) {
        state.apolloList.forEach(function (list1: any) {
          // 代理店管理者の場合
          if (list1.accountGroup.roleAuthorization >= 20) {
            let ag1: AccountGroups = {
              value: list1.accountGroup.id,
              label: list1.accountGroup.name,
            }
            accountGroups1.push(ag1);
          }
        })
      } else {
        state.apolloList.forEach(function (list1: any) {
          let ag1: AccountGroups = {
            value: list1.accountGroup.id,
            label: list1.accountGroup.name,
          }
          accountGroups1.push(ag1);
          // 選択しているアカウントグループIDをセット
          accountGroupsSelect1.map((sel) => {
            if (sel.label === list1.accountGroup.name) {
              sel.value = list1.accountGroup.id;
            }
          });
        });
      }
      setAccountGroups(accountGroups1);
      setAccountGroupsSelect(JSON.parse(JSON.stringify(accountGroups1)));
    }
  }, [accountGroupRead])

  // チェックボックスハンドラ
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    setCheckSysAd(true);

    if (event.target.checked) {
      setSystemAdmin(index + 1);
    } else {
      setSystemAdmin(0);
    }
  }
  
  const handelGoback = () => {
    const url = "/users";
    history.push(url);
  };

  let breadNo = userid === '0' ? 29 : 30;

  // 選択中のアカウントグループをオプションから除外する
  const updateAccountGroups = () => {
    // ドキュメントから選択中のアカウントグルーブを取得する
    let accountGrouops = document.querySelectorAll('[id^=role_accountgroup]');
    let accountGroupsWork:AccountGroups[] = [];
    accountGroups.forEach(function (ag1: AccountGroups) {
      let flag = false;
      accountGrouops.forEach(function (ag2: any) {
        // アカウントグループオプションのアカウントグループID(数値)と選択中のアカウントグループID(文字)を比較
        if (ag1.value + "" === ag2?.className) {
          flag = true;
        }
      });
      if (!flag) {
        // 未選択のアカウントグループを追加する
        accountGroupsWork.push(ag1);
      }
    })
    setAccountGroupsSelect(accountGroupsWork);
  }

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト(ユーザー情報)
    let itemList1: ItemList[] = [
      // {
      //   key: "ユーザーID",
      //   beforeValue: userid === "0" ? "" : userid + "",
      //   afterValue: userid === "0" ? resultData.current + "" : beforeData.current.userId + "",
      // },
      {
        key: "メールアドレス",
        beforeValue: userid === "0" ? "" : beforeData.current.mailaddress + "",
        afterValue: requestData.current.mailaddress + "",
      },
      {
        key: "ユーザー名（姓）",
        beforeValue: userid === "0" ? "" : beforeData.current.familyName + "",
        afterValue: requestData.current.familyName + "",
      },
      {
        key: "ユーザー名（名）",
        beforeValue: userid === "0" ? "" : beforeData.current.firstName + "",
        afterValue: requestData.current.firstName + "",
      },
      {
        key: "所属組織",
        beforeValue: userid === "0" ? "" : beforeData.current.organization + "",
        afterValue: requestData.current.organization + "",
      },
      {
        key: "システム権限",
        beforeValue: userid === "0" ? "" : beforeData.current.systemAdminFlg === 1 ? "システム管理権限" : beforeData.current.systemAdminFlg === 2 ? "システム運用権限" : "",
        afterValue: requestData.current.systemAdminFlg === 1 ? "システム管理権限" : requestData.current.systemAdminFlg === 2 ? "システム運用権限" : "",
      },
    ];

    // 操作ログ(ロール情報保存)
    let afterDataRole = "";
    if (userid === "0") {
      let data = requestData2.current;
      let arrData = [];
      for (var idx in data.role_id) {
        if (data.role_id[idx]) {
          arrData.push(data.role_id[idx].role_id);
        }
      }
      afterDataRole = arrData.join("，");
    }
    const itemList2: ItemList[] = [
      {
        key: "ロール",
        beforeValue: userid === "0" ? "[]" : "[" + beforeData2.current + "]",
        afterValue: userid === "0" ? "[" + afterDataRole + "]" : "[" + requestData2.current + "]",
      },
    ];

    // ユーザー情報とロール情報を結合する
    let itemList = itemList1.concat(itemList2);
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupName, // アカウントグループ名
      accountID: state.current.accountId, // 広告主アカウントID
      accountName: state.current.accountName, // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: userid === "0" ? "ユーザー新規登録画面" : "ユーザー編集画面", // 操作画面名称 〇〇画面
      category: "ユーザー", // 操作対象 キャンペーン / セグメント etc...
      actionType: userid === "0" ? "作成" : "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : userid === "0" ? resultData.current + "" : userid + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "ユーザーID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };
  
  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={breadNo} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={userid}
                          platform={""}/>
        <form onSubmit={onSubmit} autoComplete="off" onKeyDown={e => {
          if (e.key === 'Enter') e.preventDefault();
        }}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="userId"
                    name="userId"
                    label="ユーザーID"
                    required
                    fullWidth
                    disabled
                    defaultValue={
                      userid === "0" ? "自動採番" : userid
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="mailAddress"
                    name="mailAddress"
                    label="メールアドレス"
                    required
                    fullWidth
                    inputProps={{maxLength: 255}}
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      },
                      pattern: {
                        value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: 'メールアドレスの形式が正しくありません。'
                      }
                    })}
                    error={Boolean(errors.mailAddress)}
                    helperText={errors.mailAddress && errors.mailAddress.message}
                    key={user.mailaddress !== "" ? "Loaded" : "Loading"}
                    defaultValue={
                      userid === "0" ? "" : user.mailaddress
                    }
                    disabled={userid === "0" ? false : true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="familyName"
                    name="familyName"
                    label="ユーザー名（姓）"
                    required
                    fullWidth
                    inputProps={{maxLength: 255}}
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      }
                    })}
                    error={Boolean(errors.familyName)}
                    helperText={errors.familyName && errors.familyName.message}
                    key={user.mailaddress !== "" ? "Loaded" : "Loading"}
                    defaultValue={
                      userid === "0" ? "" : user.familyName
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="firstName"
                    name="firstName"
                    label="ユーザー名（名）"
                    required
                    fullWidth
                    inputProps={{maxLength: 255}}
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      }
                    })}
                    error={Boolean(errors.firstName)}
                    helperText={errors.firstName && errors.firstName.message}
                    key={user.mailaddress !== "" ? "Loaded" : "Loading"}
                    defaultValue={
                      userid === "0" ? "" : user.firstName
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="orzanization"
                    name="orzanization"
                    label="所属組織"
                    required
                    fullWidth
                    inputProps={{maxLength: 255}}
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      }
                    })}
                    error={Boolean(errors.orzanization)}
                    helperText={errors.orzanization && errors.orzanization.message}
                    key={user.mailaddress !== "" ? "Loaded" : "Loading"}
                    defaultValue={
                      userid === "0" ? "" : user.organization
                    }
                  />
                </Grid>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
                      <FormControlLabel control={
                        <Checkbox
                          id="systemAdmin"
                          name="systemAdmin"
                          color="primary"
                          onChange={(e) => handleChanges(e, 0)}
                          key={user.mailaddress !== "" ? "Loaded" : "Loading"}
                          checked={
                            systemAdmin === 1 ? true : false
                          }
                        />
                      } label="システム管理権限を付与する"
                      disabled={state.userprofile.systemAdmin === 1 || userid === "0" ? false : true}
                      />
                    </ApolloUserProfileAuth>
                  </Grid>
                  <Grid item xs={12}>
                    <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
                      <FormControlLabel control={
                        <Checkbox
                          id="systemOperate"
                          name="systemOperate"
                          color="primary"
                          onChange={(e) => handleChanges(e, 1)}
                          key={user.mailaddress !== "" ? "Loaded" : "Loading"}
                          checked={
                            systemAdmin === 2 ? true : false
                          }
                        />
                      } label="システム運用権限を付与する"
                      disabled={state.userprofile.systemAdmin === 1 || userid === "0" ? false : true}
                      />
                    </ApolloUserProfileAuth>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6" gutterBottom component="div">
                    所有ロール
                  </Typography>
                  <RoleSetGroup
                    roleIndexes={roleIndexes}
                    addRoles={addRoles}
                    removeRoles={removeRoles}
                    formHooks={formHooks}
                    accountGroups={accountGroups}
                    accountGroupsSelect={accountGroupsSelect}
                    setAccountGroupsSelect={setAccountGroupsSelect}
                    roleIds={roleIds}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction} style={{marginTop: "20em"}}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                onClick={onSubmit}
                variant="contained"
                disabled={formState.isSubmitting || processing.current}
              >
                {userid === "0" ? "作成" : "更新"}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
                disabled={formState.isSubmitting || processing.current}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </form>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default UserEdit;
